import { FeatureMouseInteraction } from '@openlayers/interaction/FeatureMouseInteraction';
import { MapOverlays } from '@openlayers/ol-overlays';
import { setMapCursor } from '@openlayers/ol-utils';
import { StringlinesLayer } from '@openlayers/stringlines/StringlinesLayer';
import { mapUI, mapWrapper } from '@pages/map/map';
import { ProjectCodesService } from '@shared/services/ProjectCodesService';
import Feature from 'ol/Feature';
import * as React from 'react';
import { observer } from 'mobx-react';
import { makeObservable } from 'mobx';
import { ReactUtils } from '@shared/ui-react/ReactUtils';


export class StringlineDesktopMouseInteraction extends FeatureMouseInteraction<StringlinesLayer> {
    onClick = (feature: Feature, e, n): void => {
        let props = feature.get('data').props;
        ['terrainCodingDesc', 'surfaceCodingDesc', 'infraCodingDesc', 'proprietaryInfraCodingDesc'].forEach(desc => {
            if (props.hasOwnProperty(desc)) {
                props[desc] = ProjectCodesService.getDescription(props[desc]) ?? props[desc];
            }
        });
        const treeNode = mapUI.mapPanels.panels.models.tree.getById(feature.get('source').modelId);
        if (treeNode) {
            props = {
                [kuura.getMessage('tablet.filename_js')]: treeNode.text,
                ...props,
            };
        }

        if (!$.isEmptyObject(props)) {
            const el = MapOverlays.showDialog(
                this.map,
                '<div class="right"><i class="iki iki-cross" onclick="mapUI.hideDialog()"></i></div><div class="react-target"></div>',
                e,
                n
            );
            setTimeout(() => {
                ReactUtils.safeRender(<ToggleProps props={props} stringlinesLayer={mapWrapper.featureLayers.stringlines} />, el.getElement().querySelector('.react-target'));
            });
        }
    };

    onMouseOver = (feature: Feature, e, n): void => {
        setMapCursor(this.map, 'pointer');
    };
}

@observer
class ToggleProps extends React.Component<{
    props: Record<string, string>;
    stringlinesLayer: StringlinesLayer;
}> {
    constructor(props: any) {
        super(props);
        makeObservable(this);
    }

    render() {
        const existingProps = this.props.stringlinesLayer.lineLabelProps.map(prop => prop.toLowerCase());

        return (
            <div className='padded-half' style={{ maxHeight: 300, overflowY: 'auto' }}>
                <table>
                    <tbody>
                        {Object.entries(this.props.props).map(([key, value]) => (
                            <tr key={key}>
                                <td>
                                    {key !== 'Filename' && (
                                        <input
                                            type='checkbox'
                                            checked={existingProps.includes(key.toLowerCase())}
                                            onClick={() => this.props.stringlinesLayer.toggleLineLabelProp(key.toLowerCase())}
                                            readOnly={true}
                                            title={__('js_map.labels.show_label_on_map')}
                                        />
                                    )}
                                </td>
                                <td>
                                    <div className='flex-row ai-center' style={{ gap: '1ch' }}>
                                        <div style={{ whiteSpace: 'nowrap', flex: 0 }}>{key}: </div>
                                        <div className='break-text' style={{ maxWidth: 500 }}>
                                            {value}
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        );
    }
}
